// eslint-disable-next-line import/prefer-default-export
export function exitKiosk(path, redirectUrl) {
  // Hard navigation clears form state, Apollo cache, and any other
  // in-memory state left over from the previous guest.
  window.location.href = redirectUrl || `/${path}/response?kiosk=true`;
}
